import { Form, Table } from 'antd';
import { PureQueryOptions } from 'apollo-client';
import * as moment from 'moment';
import React, { Component, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { FormatDate } from 'src/components/table/Date';
import { RedeemCode, RedeemCodeRecord } from 'src/types/redeemCode';
import { mobileMasking } from 'src/utils/masking';

import { RedeemCodeRecordType } from '../../types/redeemCode';
import { DestroyRedeemCode } from './destroyRedeemCode';
import { ExchangeRedeemCode } from './ExchangeRedeemCode';
import { ExpiredStatus, UsedStatus } from './RedeemCodeList';

const ExchangeRedeemCodeForm: any = Form.create()(ExchangeRedeemCode);
interface Props {
  redeemCodes: RedeemCode[];
  tabelListType: number;
  footer?: (currentPageData: RedeemCode[]) => ReactNode;
  isDefaultPaginationOn?: boolean;
  price?: number;
  activityPrice?: number;
  cost?: number;
  marketingCost?: number;
  refetchQueries: PureQueryOptions[];
}
interface State {}

export enum TableType {
  REDEEMCODE,
  REDEEMCODEDETAIL,
}

export class RedeemCodeTableList extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  defaultPagination = () => {
    const { redeemCodes, tabelListType } = this.props;
    if (this.props.isDefaultPaginationOn) {
      return {
        total: redeemCodes.length, // 数据总数量
        defaultPageSize: 10, // 默认显示几条一页
        showSizeChanger: true, // 是否显示可以设置几条一页的选项
        showTotal: () => {
          return tabelListType === TableType.REDEEMCODE
            ? `共 ${redeemCodes.length} 个兑换码(最多100条)`
            : `共 ${redeemCodes.length} 个`;
        },
      };
    }
    return false;
  };

  render() {
    const { tabelListType } = this.props;
    return (
      <Table<RedeemCode>
        dataSource={this.props.redeemCodes}
        pagination={this.defaultPagination()}
        rowKey={row => `${row.id}`}
        footer={this.props.footer}
      >
        <Table.Column dataIndex="id" title="ID" key="id" width={80} />
        <Table.Column dataIndex="code" title="兑换码" key="code" />
        {tabelListType === TableType.REDEEMCODE && (
          <Table.Column dataIndex="template.channel" title="渠道" key="channel" />
        )}
        {tabelListType === TableType.REDEEMCODE && <Table.Column dataIndex="template.desc" title="描述" key="desc" />}
        <Table.Column
          dataIndex="createdAt"
          key="createdAt"
          title="生成日期"
          render={createdAt => <FormatDate mode="datetime" date={createdAt} />}
        />
        <Table.Column key="price" title="市场价" render={() => this.props.price || '-'} />
        <Table.Column key="activityPrice" title="活动价" render={() => this.props.activityPrice || '-'} />
        <Table.Column key="cost" title="课程成本" render={() => this.props.cost || '-'} />
        <Table.Column key="marketingCost" title="市场课程成本" render={() => this.props.marketingCost || '-'} />
        <Table.Column
          dataIndex="redeemRecords"
          key="redeemCodeCreatedAt"
          title="兑换日期"
          render={redeemRecords => {
            const used = redeemRecords.find((record: RedeemCodeRecord) => record.type === RedeemCodeRecordType.USED);
            if (used) {
              return <FormatDate mode="datetime" date={used.createdAt} />;
            }
            return '-';
          }}
        />
        <Table.Column
          dataIndex="redeemRecords"
          title="兑换用户"
          key="userName"
          render={redeemRecords => {
            const used = redeemRecords.find((record: RedeemCodeRecord) => record.type === RedeemCodeRecordType.USED);
            if (used && used.user) {
              return <Link to={`/user/${used.userId}`}>{used.user.name}</Link>;
            }
            return '-';
          }}
        />
        <Table.Column
          dataIndex="redeemRecords"
          title="兑换用户手机号"
          key="userTel"
          render={redeemRecords => {
            const used = redeemRecords.find((record: RedeemCodeRecord) => record.type === RedeemCodeRecordType.USED);
            if (used && used.user) {
              const maskedMobile = mobileMasking(used.user.mobile);
              return maskedMobile;
            }
            return '-';
          }}
        />
        {tabelListType === TableType.REDEEMCODE && (
          <Table.Column
            dataIndex="template.duration"
            key="duration"
            title="有效期"
            render={duration => `生成${moment.duration(duration, 'seconds').humanize()}内有效`}
          />
        )}
        <Table.Column
          dataIndex="redeemRecords"
          key="allocatedMobile"
          title="发放用户手机号"
          render={redeemRecords => {
            const allocated = redeemRecords.find(
              (record: RedeemCodeRecord) => record.type === RedeemCodeRecordType.ALLOCATED,
            );
            if (allocated && allocated.user) {
              const maskedMobile = mobileMasking(allocated.user.mobile);
              return <Link to={`/user/${allocated.userId}`}>{maskedMobile}</Link>;
            }
            return '-';
          }}
        />
        <Table.Column
          key="actions"
          title="操作"
          render={row => {
            const redeemRecords = row.redeemRecords;
            const used = redeemRecords.find((record: RedeemCodeRecord) => record.type === RedeemCodeRecordType.USED);
            const destroyed = redeemRecords.find(
              (record: RedeemCodeRecord) => record.type === RedeemCodeRecordType.DESTROYED,
            );
            if (used) {
              return <UsedStatus>已兑换</UsedStatus>;
            }
            if (destroyed) {
              return <ExpiredStatus>已作废</ExpiredStatus>;
            }
            if (moment().isBefore(row.invalidAt)) {
              return (
                <>
                  <DestroyRedeemCode redeemCodeId={row.id} />
                  <ExchangeRedeemCodeForm redeemCode={row.code} refetchQueries={this.props.refetchQueries} />
                </>
              );
            }
            return <ExpiredStatus>已失效</ExpiredStatus>;
          }}
        />
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/redeemCode/RedeemCodeTableList.tsx